export const walkthroughHelpers = [
  {
    category: 'Store',
    page: 'Designer',
    elements: [
      { label: 'Product Images', className: 'intro-designer-images-list' },
      { label: 'Part Color', className: 'intro-configure-color' },
      { label: 'Decoration', className: 'intro-configure-decoration' },
      { label: 'Designer', className: 'intro-designer' },
      { label: 'Additional Options', className: 'intro-configure-additional-options' },
      { label: 'Upload Artwork', className: 'intro-configure-upload-artwork' },
      { label: 'Decoration Location', className: 'intro-configure-decoration-locaiton' },
      { label: 'Decoration Method', className: 'intro-configure-decoration-method' },
      { label: 'Decoration Comments', className: 'intro-configure-decoration-comments' },
      { label: 'Decoration Color(s)', className: 'intro-configure-decoration-colors' }
    ]
  },
  {
    category: 'Store',
    page: 'Customizer',
    elements: [
      { label: 'Product Images', className: 'intro-designer-images-list' },
      { label: 'Part Color', className: 'intro-configure-color' },
      { label: 'Decoration', className: 'intro-configure-decoration' },
      { label: 'Designer', className: 'intro-designer' },
      { label: 'Additional Options', className: 'intro-configure-additional-options' },
      { label: 'Upload Artwork', className: 'intro-configure-upload-artwork' },
      { label: 'Decoration Location', className: 'intro-configure-decoration-locaiton' },
      { label: 'Decoration Method', className: 'intro-configure-decoration-method' },
      { label: 'Decoration Comments', className: 'intro-configure-decoration-comments' },
      { label: 'Decoration Color(s)', className: 'intro-configure-decoration-colors' }
    ]
  },
  {
    category: 'App',
    page: 'App navigation',
    routeName: 'dashboard',
    elements: [
      { label: 'Left Nav Bar', className: 'intro-app-left-nav', position: 'right' },
      { label: 'Nav Expand', className: 'intro-app-nav-expand' },
      { label: 'Search', className: 'intro-app-search-global' },
      { label: 'New Icon', className: 'intro-app-create-new' },
      { label: 'Bell Icon', className: 'intro-app-notifications' },
      { label: 'Question mark', className: 'intro-app-help' },
      { label: 'Account Icon', className: 'intro-app-account' },
      { label: "What's New", className: 'intro-app-whats-new' }
    ]
  },
  {
    category: 'App',
    page: 'Orders',
    routeName: 'app/orders/',
    elements: [
      { label: 'Follow Ups', className: 'intro-orders-follow-ups-tab' },
      { label: 'Orders', className: 'intro-orders-list-tab' },
      { label: 'Board', className: 'intro-orders-board-tab' },
      { label: 'POs', className: 'intro-orders-pos-list-tab' },
      { label: 'Recent', className: 'intro-orders-recent-tab' },
      { label: 'Create Orders', className: 'intro-orders-list-create' }
    ]
  },
  {
    category: 'App',
    page: 'Customers',
    routeName: 'app/customers/',
    elements: [
      { label: 'Customer Follow Ups', className: 'intro-customer-follow-ups-tab' },
      { label: 'Customers', className: 'intro-customer-list-tab' },
      { label: 'Companies', className: 'intro-customer-company-list-tab' },
      { label: 'Presentations', className: 'intro-customer-presentations-tab' },
      { label: 'New Customer', className: 'intro-customer-new' },
      { label: 'Customer Import', className: 'intro-customer-import' },
      { label: 'New Company', className: 'intro-customer-new-company' },
      { label: 'New Presentation', className: 'intro-customer-new-presentation' },
      { label: 'Emails', className: 'intro-customer-email-tab' }
    ]
  },
  {
    category: 'App',
    page: 'Customer View',
    routeName: 'app/customers/:customerId',
    elements: [
      { label: 'Rank', className: 'intro-customer-rank' },
      { label: 'Billing & Tax information', className: 'intro-customer-billing-tax' },
      { label: 'Follow Ups', className: 'intro-customer-follow-ups' },
      { label: 'Notes', className: 'intro-customer-notes' },
      { label: 'History', className: 'intro-customer-history' },
      { label: 'Tabs', className: 'intro-customer-tabs' },
      { label: 'Information', className: 'intro-customer-information-tab' },
      { label: 'Artwork', className: 'intro-customer-artwork-tab' },
      { label: 'Email', className: 'intro-customer-email-tab' },
      { label: 'Orders', className: 'intro-customer-orders-tab' },
      { label: 'Presentations', className: 'intro-customer-presentations-tab' },
      { label: 'Documents', className: 'intro-customer-documents-tab' },
      { label: 'Addresses', className: 'intro-customer-addresses-tab' },
      { label: 'Stores', className: 'intro-customer-stores-tab' },
      { label: 'Help', className: 'intro-customer-help' }
    ]
  },
  {
    category: 'App',
    page: 'Stores',
    routeName: 'app/stores',
    elements: [{ label: 'Create Store', className: 'intro-stores-create' }]
  },
  {
    category: 'App',
    page: 'Store Builder',
    routeName: 'app/stores/:storeId',
    elements: [
      { label: 'Nav Bar', className: 'intro-store-navbar' },
      { label: 'Resize', className: 'intro-store-resize' },
      { label: 'Browser Device', className: 'intro-store-browser-device' },
      { label: 'Theme', className: 'intro-store-theme' },
      { label: 'Components', className: 'intro-store-components' },
      { label: 'Pages', className: 'intro-store-pages' },
      { label: 'Media', className: 'intro-store-media' },
      { label: 'Headtags', className: 'intro-store-headtags' },
      { label: 'Categories', className: 'intro-store-categories' },
      { label: 'Products', className: 'intro-store-products' },
      { label: 'Suppliers', className: 'intro-store-suppliers' },
      { label: 'Product Codes', className: 'intro-store-product-codes' },
      { label: 'Ads', className: 'intro-store-product-feed' },
      { label: 'Social Media', className: 'intro-store-social-media' },
      { label: 'Robots', className: 'intro-store-robots' },
      { label: 'Sitemaps', className: 'intro-store-sitemaps' },
      { label: 'Customers', className: 'intro-store-customers' },
      { label: 'Discount Codes', className: 'intro-store-discount-codes' },
      { label: 'Allowances & Credits', className: 'intro-store-allowances-credits' },
      { label: 'Specials', className: 'intro-store-specials' },
      { label: 'Payments', className: 'intro-store-payment' },
      { label: 'Reviews', className: 'intro-store-reviews' },
      { label: 'Shipping', className: 'intro-store-shipping' },
      { label: 'Artwork', className: 'intro-store-artwork' },
      { label: 'Information', className: 'intro-store-information' },
      { label: 'Communication', className: 'intro-store-communication' },
      { label: 'Configuration', className: 'intro-store-configuration' },
      { label: 'Roles', className: 'intro-store-roles' },
      { label: 'Fulfillment', className: 'intro-store-fulfillment' },
      { label: 'Recaptcha', className: 'intro-store-recaptcha' },
      { label: 'Reports', className: 'intro-store-reports' },
      { label: 'Reference', className: 'intro-store-reference' },
      { label: 'SSO', className: 'intro-store-sso' },
      { label: 'Walkthrough', className: 'intro-store-walkthrough' },
      { label: 'Help', className: 'intro-store-help' }
    ]
  },
  {
    category: 'App',
    page: 'Products',
    routeName: 'app/products',
    elements: [
      { label: 'MPower Products', className: 'intro-products-mpower-tab' },
      { label: 'Presentation Products', className: 'intro-products-presentation-products-button' }
    ]
  },
  {
    category: 'App',
    page: 'Suppliers',
    routeName: 'app/suppliers',
    elements: [{ label: 'Create Supplier', className: 'info-suppliers-create' }]
  },
  {
    category: 'App',
    page: 'Supplier',
    routeName: 'app/suppliers/:supplierId',
    elements: [
      { label: 'General', className: 'intro-supplier-general-tab' },
      { label: 'Pricing', className: 'intro-supplier-pricing-tab' }
    ]
  },
  {
    category: 'App',
    page: 'Order View',
    routeName: 'app/orders/:orderId',
    elements: [
      { label: 'Order Id', className: 'intro-order-id' },
      { label: 'Order History', className: 'intro-order-history-button' },
      { label: 'Send Order', className: 'intro-order-send-button' },
      { label: 'Print Order', className: 'intro-order-print-button' },
      { label: 'Flag Order', className: 'intro-order-flag-button' },
      { label: 'Order Actions', className: 'intro-order-actions-button' },
      { label: 'Users', className: 'intro-order-users' },
      { label: 'Sales User', className: 'intro-order-sales' },
      { label: 'Sales Administrator', className: 'intro-order-sales-administrator' },
      { label: 'Order Dates', className: 'intro-order-dates' },
      { label: 'Order Status', className: 'intro-order-status' },
      { label: 'Discount', className: 'intro-order-discount' },
      { label: 'Commissions', className: 'intro-order-commission' },
      { label: 'Payments', className: 'intro-order-payments' },
      { label: 'Payment Methods', className: 'intro-order-payment-methods' },
      { label: 'Customer', className: 'intro-order-customer' },
      { label: 'Totals', className: 'intro-order-totals' },
      { label: 'Store', className: 'intro-order-store' },
      { label: 'Due Date', className: 'intro-order-due-date' },
      { label: 'Is Rush', className: 'intro-order-rush' },
      { label: 'Is Firm', className: 'intro-order-firm' },
      { label: 'PO Tab', className: 'intro-order-po-tab' },
      { label: 'Documents Tab', className: 'intro-order-documents-tab' },
      { label: 'Add Product', className: 'intro-order-add-product' },
      { label: 'Add Custom Product', className: 'intro-order-add-custom-product' },
      { label: 'References', className: 'info-order-referenes' },
      { label: 'Internal Comments', className: 'intro-order-internal-comments' },
      { label: 'External Comments', className: 'intro-order-external-comments' },
      { label: 'Follow Ups', className: 'intro-order-follow-ups' },
      { label: 'Need Help?', className: 'intro-order-help' }
    ]
  },
  {
    category: 'App',
    page: 'PO Form',
    routeName: 'app/orders/:orderId/purchase-orders/:friendlyPurchaseOrderDetailId',
    elements: [
      { label: 'PO ID', className: 'intro-po-id' },
      { label: 'PO Status', className: 'intro-po-status' },
      { label: 'PO Type', className: 'intro-po-type' },
      { label: 'Supplier Promo Code', className: 'intro-po-supplier-promo-code' },
      { label: 'Require Digital Proof', className: 'intro-po-require-proof' },
      { label: 'Rush Production', className: 'intro-po-rush-production' },
      { label: 'Customer', className: 'intro-po-customer' },
      { label: 'Customer Comments', className: 'intro-po-customer-comments' },
      { label: 'Billing Comments', className: 'intro-po-billing-comments' },
      { label: 'Internal Comments', className: 'intro-po-internal-comments' },
      { label: 'Suppier Comments', className: 'intro-po-supplier-comments' },
      { label: 'External Comments', className: 'intro-po-external-comments' },
      { label: 'Supplier', className: 'intro-po-supplier' },
      { label: 'PO Shipment', className: 'intro-po-shipment' },
      { label: 'PO Line', className: 'intro-po-line' },
      { label: 'PO Line Shipment', className: 'intro-po-line-shipment' },
      { label: 'PO Part', className: 'intro-po-part' },
      { label: 'PO Part Shipment', className: 'intro-po-part-shipment' },
      { label: 'PO Charge', className: 'intro-po-charge' },
      { label: 'PO Location', className: 'intro-po-location' },
      { label: 'Request Proof', className: 'intro-po-request-proof' },
      { label: 'Product Discount', className: 'intro-po-product-discount' },
      { label: 'Tax Rate', className: 'intro-po-tax-rate' },
      { label: 'Tax Exempt', className: 'intro-po-tax-exempt' },
      { label: 'Shipping Discount', className: 'intro-po-shipping-discount' },
      { label: 'Need Help?', className: 'intro-po-help' }
    ]
  },
  {
    category: 'App',
    page: 'My Account',
    routeName: 'my-account',
    elements: [
      { label: 'Account Tab', className: 'intro-account-tab' },
      { label: 'Notifications Tab', className: 'intro-account-notifications-tab' },
      { label: 'Commissions Tab', className: 'intro-account-commissions-tab' }
    ]
  },
  {
    category: 'App',
    page: 'Users',
    routeName: 'app/users',
    elements: [{ label: 'Create User', className: 'intro-users-create' }]
  },
  {
    category: 'App',
    page: 'My Distributor',
    routeName: 'app/distributors',
    elements: [
      { label: 'Information', className: 'intro-distributor-info' },
      { label: 'Contacts', className: 'intro-distributor-contacts' },
      { label: 'Addresses', className: 'intro-distributor-addresses' },
      { label: 'Shipping', className: 'intro-distributor-shipping' },
      { label: 'Notifications', className: 'intro-distributor-notifications' },
      { label: 'Decorators', className: 'intro-distributor-decorators' },
      { label: 'API Tokens', className: 'intro-distributor-api-tokens' },
      { label: 'Tax', className: 'intro-distributor-tax' },
      { label: 'Default Store', className: 'intro-distributor-default-store' },
      { label: 'Quickbooks', className: 'intro-distributor-quickbooks' },
      { label: 'SendGrid', className: 'intro-distributor-sendgrid' },
      { label: 'Zoho', className: 'intro-distributor-zoho' },
      { label: 'Hubspot', className: 'intro-distributor-hubspot' }
    ]
  },
  {
    category: 'App',
    page: 'Presentation Create',
    routeName: 'app/presentations/create',
    elements: [
      { label: 'Template', className: 'intro-presentation-template' },
      { label: 'Store', className: 'intro-presentation-store' },
      { label: 'Name', className: 'intro-presentation-name' },
      { label: 'Company', className: 'intro-presentation-company' },
      { label: 'Customers', className: 'intro-presentation-customers' },
      { label: 'Layout', className: 'intro-presentation-layout' },
      { label: 'Logos', className: 'intro-presentation-logos' },
      { label: 'Is Template', className: 'intro-presentation-istemplate' },
      { label: 'Is Public', className: 'intro-presentation-ispublic' },
      { label: 'Need Help?', className: 'intro-presentation-help' }
    ]
  },
  {
    category: 'App',
    page: 'Presentation Edit',
    routeName: 'app/presentations/edit',
    elements: [
      { label: 'Send', className: 'intro-presentation-send' },
      { label: 'Add Product', className: 'intro-presentation-add-product' },
      { label: 'Add HTML', className: 'intro-presentation-add-html' }
    ]
  },
  {
    category: 'App',
    page: 'Presentation Send',
    routeName: 'app/presentations/send',
    elements: [
      { label: 'Recipients', className: 'intro-presentation-send-recipients' },
      { label: 'Comments', className: 'intro-presentation-send-comments' }
    ]
  }
];
